
import de_1 from "date-fns/locale/de";
import en_GB from "date-fns/locale/en-GB";
import { currentLanguage } from "../LocalStorageHelper.js";
import { toArray as toArray_1, fold, append as append_1, empty, forAll as forAll_1, ofArray } from "../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { day as day_1, month as month_1, year as year_1, create, daysInMonth } from "../fable_modules/fable-library-js.5.0.0-rc.2/Date.js";
import { match } from "../fable_modules/fable-library-js.5.0.0-rc.2/RegExp.js";
import { parse as parse_1 } from "../fable_modules/fable-library-js.5.0.0-rc.2/Int32.js";
import { singleton, empty as empty_1, append, delay, toList, forAll } from "../fable_modules/fable-library-js.5.0.0-rc.2/Seq.js";
import { defaultOf, equals, createObj, equalArrays, compareArrays } from "../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { defaultArg, map, toArray } from "../fable_modules/fable-library-js.5.0.0-rc.2/Option.js";
import { reactElement, reactApi } from "../fable_modules/Feliz.2.9.0/Interop.fs.js";
import React from "react";
import { concat, join } from "../fable_modules/fable-library-js.5.0.0-rc.2/String.js";
import { reactApi as reactApi_1 } from "../fable_modules/Feliz.2.9.0/Interop.fs.js";
import react_datepicker from "react-datepicker";
import { item, equalsWith } from "../fable_modules/fable-library-js.5.0.0-rc.2/Array.js";

export const de = de_1;

export const en = en_GB;

export function currentLocale(_arg) {
    const matchValue = currentLanguage(undefined);
    switch (matchValue) {
        case "de":
            return de;
        case "en":
            return en;
        default:
            return de;
    }
}

export const dateFormats = ofArray(["dd.MM.yyyy", "d.MM.yyyy", "dd.M.yyyy", "d.M.yyyy"]);

export const monthYearFormats = ofArray(["MM.yyyy", "M.yyyy"]);

const shortYearDate = /^\s*(\d{1,2})\.(\d{1,2})\.(\d{2})\s*$/gu;

function localDate(year, month, day) {
    if ((((month >= 1) && (month <= 12)) && (day >= 1)) && (day <= daysInMonth(year, month))) {
        return create(year, month, day);
    }
    else {
        return undefined;
    }
}

export function parseShortYearDate(text) {
    const m = match(shortYearDate, text);
    if (m != null) {
        return localDate(2000 + parse_1(m[3] || "", 511, false, 32), parse_1(m[2] || "", 511, false, 32), parse_1(m[1] || "", 511, false, 32));
    }
    else {
        return undefined;
    }
}

function toUtcDate(date) {
    return create(year_1(date), month_1(date), day_1(date), 0, 0, 0, 0, 1);
}

function calendarDay(date) {
    return [year_1(date), month_1(date), day_1(date)];
}

function isAllowed(minDate, maxDate, excludedDates, date) {
    const day = calendarDay(date);
    if (forAll((minDate_1) => (compareArrays(day, calendarDay(minDate_1)) >= 0), toArray(minDate)) && forAll((maxDate_1) => (compareArrays(day, calendarDay(maxDate_1)) <= 0), toArray(maxDate))) {
        return forAll_1((excluded) => !equalArrays(calendarDay(excluded), day), excludedDates);
    }
    else {
        return false;
    }
}

function useTypedText(parse, normalize, allowed, onChange) {
    const typedText = reactApi.useRef("");
    const commitTypedText = () => {
        const matchValue = parse(typedText.current);
        let matchResult, date_1;
        if (matchValue != null) {
            if (allowed(matchValue)) {
                matchResult = 0;
                date_1 = matchValue;
            }
            else {
                matchResult = 1;
            }
        }
        else {
            matchResult = 1;
        }
        switch (matchResult) {
            case 0: {
                typedText.current = "";
                onChange(normalize(date_1));
                break;
            }
            case 1: {
                break;
            }
        }
    };
    return ofArray([["strictParsing", true], ["onChangeRaw", (ev) => {
        typedText.current = ev.target.value;
    }], ["onChange", (date_2) => {
        typedText.current = "";
        onChange(map(normalize, date_2));
    }], ["onBlur", (_arg) => {
        commitTypedText();
    }], ["onCalendarClose", commitTypedText]]);
}

export function DatePicker(props) {
    let excludedDates, elems;
    const typedTextProps = useTypedText(parseShortYearDate, toUtcDate, (excludedDates = defaultArg(props.ExcludedDates, empty()), (date_1) => isAllowed(props.MinDate, props.MaxDate, excludedDates, date_1)), props.OnChange);
    return reactElement("div", createObj(ofArray([["data-test-id", props.TestId], ["className", join(" ", ["flex", "flex-col", "gap-1.5"])], (elems = toList(delay(() => {
        let matchValue, label;
        return append((matchValue = props.Label, (matchValue == null) ? (empty_1()) : ((label = matchValue, singleton(reactElement("label", {
            className: join(" ", ["text-sm", "font-bold"]),
            children: label,
        }))))), delay(() => {
            let props_1;
            return append(singleton((props_1 = append_1(typedTextProps, toList(delay(() => append(singleton(["className", fold((a, b) => concat(a, " ", ...b), "", ofArray(["bg-white", "border", "border-[#B6BECB]", "focus:border-primary", "focus:outline-none", "text-base", "font-normal", "rounded-lg", "h-10", "w-full", "px-3", "disabled:bg-background", "disabled:text-text-muted", "disabled:cursor-not-allowed"]))]), delay(() => {
                let matchValue_1;
                return append((matchValue_1 = props.Value, (matchValue_1 == null) ? (empty_1()) : singleton(["selected", matchValue_1])), delay(() => append(singleton(["dateFormat", toArray_1(dateFormats)]), delay(() => append(singleton(["locale", currentLocale(undefined)]), delay(() => {
                    let matchValue_2;
                    return append((matchValue_2 = props.StartDate, (matchValue_2 == null) ? (empty_1()) : singleton(["startDate", matchValue_2])), delay(() => {
                        let matchValue_3;
                        return append((matchValue_3 = props.EndDate, (matchValue_3 == null) ? (empty_1()) : singleton(["endDate", matchValue_3])), delay(() => {
                            let matchValue_4;
                            return append((matchValue_4 = props.MinDate, (matchValue_4 == null) ? (empty_1()) : singleton(["minDate", matchValue_4])), delay(() => {
                                let matchValue_5;
                                return append((matchValue_5 = props.MaxDate, (matchValue_5 == null) ? (empty_1()) : singleton(["maxDate", matchValue_5])), delay(() => {
                                    let matchValue_6;
                                    return append((matchValue_6 = props.ExcludedDates, (matchValue_6 == null) ? (empty_1()) : singleton(["excludedDates", toArray_1(matchValue_6)])), delay(() => append(singleton(["isClearable", props.IsClearable]), delay(() => singleton(["disabled", props.ComponentState === "disabled"])))));
                                }));
                            }));
                        }));
                    }));
                }))))));
            }))))), reactApi_1.createElement(react_datepicker, createObj(props_1)))), delay(() => {
                const matchValue_8 = props.ValidationMessage;
                if (matchValue_8 == null) {
                    return empty_1();
                }
                else {
                    const message = matchValue_8;
                    return singleton(reactElement("div", {
                        className: join(" ", ["text-[#dc3545]", "text-xs", "mt-1"]),
                        children: message,
                    }));
                }
            }));
        }));
    })), ["children", reactApi.Children.toArray(Array.from(elems))])])));
}

export function RangeDatePicker(props) {
    let elems;
    return reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "gap-1.5"])], (elems = toList(delay(() => {
        let matchValue, label;
        return append((matchValue = props.Label, (matchValue == null) ? (empty_1()) : ((label = matchValue, singleton(reactElement("label", {
            className: join(" ", ["text-sm", "font-bold"]),
            children: label,
        }))))), delay(() => {
            let props_1;
            return singleton((props_1 = toList(delay(() => append(singleton(["className", fold((a, b) => concat(a, " ", ...b), "", ofArray(["bg-white", "border", "border-[#B6BECB]", "focus:border-primary", "focus:outline-none", "text-base", "font-normal", "rounded-lg", "h-10", "w-full", "px-3", "disabled:bg-background", "disabled:text-text-muted", "disabled:cursor-not-allowed"]))]), delay(() => append(singleton(["selectsRange", true]), delay(() => append(singleton(["portalId", "react-datepicker-portal"]), delay(() => append(singleton(["popperClassName", "react-datepicker-popper-portal"]), delay(() => append(singleton(["onChange", (dateRange) => {
                let testExpr, testExpr_1;
                let matchResult, startDate, endDate, startDate_1;
                if (dateRange == null) {
                    matchResult = 2;
                }
                else if ((testExpr = dateRange, !equalsWith(equals, testExpr, defaultOf()) && (testExpr.length === 1))) {
                    if (item(0, dateRange) != null) {
                        matchResult = 0;
                        startDate = item(0, dateRange);
                    }
                    else {
                        matchResult = 2;
                    }
                }
                else if ((testExpr_1 = dateRange, !equalsWith(equals, testExpr_1, defaultOf()) && (testExpr_1.length === 2))) {
                    if (item(0, dateRange) == null) {
                        if (item(1, dateRange) == null) {
                            matchResult = 2;
                        }
                        else {
                            matchResult = 2;
                        }
                    }
                    else if (item(1, dateRange) != null) {
                        matchResult = 1;
                        endDate = item(1, dateRange);
                        startDate_1 = item(0, dateRange);
                    }
                    else {
                        matchResult = 0;
                        startDate = item(0, dateRange);
                    }
                }
                else {
                    matchResult = 2;
                }
                switch (matchResult) {
                    case 0: {
                        props.OnChange({
                            StartDate: startDate,
                        });
                        break;
                    }
                    case 1: {
                        props.OnChange({
                            EndDate: endDate,
                            StartDate: startDate_1,
                        });
                        break;
                    }
                    case 2: {
                        props.OnChange(undefined);
                        break;
                    }
                }
            }]), delay(() => append(singleton(["dateFormat", "dd.MM.yyyy"]), delay(() => append(singleton(["locale", currentLocale(undefined)]), delay(() => {
                let matchValue_1;
                return append((matchValue_1 = props.StartDate, (matchValue_1 == null) ? (empty_1()) : singleton(["startDate", matchValue_1])), delay(() => {
                    let matchValue_2;
                    return append((matchValue_2 = props.EndDate, (matchValue_2 == null) ? (empty_1()) : singleton(["endDate", matchValue_2])), delay(() => {
                        let matchValue_3;
                        return append((matchValue_3 = props.MinDate, (matchValue_3 == null) ? (empty_1()) : singleton(["minDate", matchValue_3])), delay(() => {
                            let matchValue_4;
                            return append((matchValue_4 = props.MaxDate, (matchValue_4 == null) ? (empty_1()) : singleton(["maxDate", matchValue_4])), delay(() => append(singleton(["isClearable", props.IsClearable]), delay(() => singleton(["disabled", props.ComponentState === "disabled"])))));
                        }));
                    }));
                }));
            })))))))))))))))), reactApi_1.createElement(react_datepicker, createObj(props_1))));
        }));
    })), ["children", reactApi.Children.toArray(Array.from(elems))])])));
}

export function MonthYearDatePicker(props) {
    let elems;
    return reactElement("div", createObj(ofArray([["data-test-id", props.TestId], ["className", join(" ", ["flex", "flex-col", "gap-1.5"])], (elems = toList(delay(() => {
        let matchValue, label;
        return append((matchValue = props.Label, (matchValue == null) ? (empty_1()) : ((label = matchValue, singleton(reactElement("label", {
            className: join(" ", ["text-sm", "font-bold"]),
            children: label,
        }))))), delay(() => {
            let props_1;
            return singleton((props_1 = toList(delay(() => append(singleton(["className", fold((a, b) => concat(a, " ", ...b), "", ofArray(["bg-white", "border", "border-[#B6BECB]", "focus:border-primary", "focus:outline-none", "text-base", "font-normal", "rounded-lg", "h-10", "w-full", "px-3", "disabled:bg-background", "disabled:text-text-muted", "disabled:cursor-not-allowed"]))]), delay(() => {
                let matchValue_1;
                return append((matchValue_1 = props.Value, (matchValue_1 == null) ? (empty_1()) : singleton(["selected", matchValue_1])), delay(() => append(singleton(["onChange", props.OnChange]), delay(() => append(singleton(["strictParsing", true]), delay(() => append(singleton(["dateFormat", toArray_1(monthYearFormats)]), delay(() => append(singleton(["locale", currentLocale(undefined)]), delay(() => {
                    let matchValue_2;
                    return append((matchValue_2 = props.StartDate, (matchValue_2 == null) ? (empty_1()) : singleton(["startDate", matchValue_2])), delay(() => {
                        let matchValue_3;
                        return append((matchValue_3 = props.EndDate, (matchValue_3 == null) ? (empty_1()) : singleton(["endDate", matchValue_3])), delay(() => {
                            let matchValue_4;
                            return append((matchValue_4 = props.MinDate, (matchValue_4 == null) ? (empty_1()) : singleton(["minDate", matchValue_4])), delay(() => {
                                let matchValue_5;
                                return append((matchValue_5 = props.MaxDate, (matchValue_5 == null) ? (empty_1()) : singleton(["maxDate", matchValue_5])), delay(() => append(singleton(["isClearable", props.IsClearable]), delay(() => append(singleton(["disabled", props.ComponentState === "disabled"]), delay(() => singleton(["showMonthYearPicker", true])))))));
                            }));
                        }));
                    }));
                }))))))))));
            })))), reactApi_1.createElement(react_datepicker, createObj(props_1))));
        }));
    })), ["children", reactApi.Children.toArray(Array.from(elems))])])));
}

